export default __webpack_public_path__ + "9c6002662bcd4f6d411d4f176deaed5d.png";